import { useQuery } from "@tanstack/react-query";
import { userService } from "../services/user";
import { useAuthUser } from "./useAuthUser";
import { useMemo } from "react";

export function useUserSubscriptionAddons(addons = []) {
  const { user } = useAuthUser();

  const { data: subscriptionAddonsRaw, ...rest } = useQuery({
    enabled: !!user?.uid,
    gcTime: 30 * 60 * 1000,
    queryKey: ["getSubscriptionAddons_key", user?.uid, [...addons].sort()],
    retry: 1,
    staleTime: 5 * 60 * 1000,
    queryFn: () =>
      userService.getSubscriptionAddons({ addons, userId: user?.uid }),
  });

  const subscriptionAddons = useMemo(
    () =>
      subscriptionAddonsRaw?.filter((addon) => addon.status !== "canceled") ??
      [],
    [subscriptionAddonsRaw]
  );

  return {
    brysonAddon: subscriptionAddons.some(
      (addon) => addon.addonType === "BRYSON_ADDON"
    ),
    llmAddon: subscriptionAddons.some(
      (addon) => addon.addonType === "LLM_ADDON"
    ),
    subscriptionAddons,
    ...rest,
  };
}
